import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-http-backend";
import translation from '../../lang';

export const languages = ["en", "ru", "it", "de", "nl"];
export const LANG = [{
    title: "Russian",
    short: "RU",
    value: "ru",
    flag: "ru",
}, {
    title: "English",
    short: "EN",
    value: "en",
    flag: "us",
}, {
    title: "Dutch",
    short: "NL",
    value: "nl",
    flag: "nl",
}, {
    title: "Italian",
    short: "IT",
    value: "it",
    flag: "it",
}, {
    title: "German",
    short: "DE",
    value: "de",
    flag: "de",
}];

const resources = {
    en: {
        translation: {
            landing: translation.landing.EN,
            discover: translation.discover.EN,
            dashboard: translation.dashboard.EN
        }
    },
    ru: {
        translation: {
            landing: translation.landing.RU,
            discover: translation.discover.RU,
            dashboard: translation.dashboard.RU
        },
    },
    de: {
        translation: {
            landing: translation.landing.DE,
        },
    },
    it: {
        translation: {
            landing: translation.landing.IT,
        },
    },
    nl: {
        translation: {
            landing: translation.landing.NL,
        },
    },
};

i18n
    .use(initReactI18next)
    .use(XHR)
    // .use(LanguageDetector)
    .init({
        detection: {
            order: ['sessionStorage', 'navigator'],
            lookupFromPathIndex: 0,
            checkWhitelist: true,
        },
        resources: resources,
        whitelist: languages,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        }
    });


export default i18n;
